import React, { useState, useEffect } from 'react';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import * as UI from '../constantes/UI.js';
import MensajeError from '../UI/MensajeError.js';

const SelectDivision = (props) => {
  const divisionActual = props.divisionActual;
  const idPais = props.idPais;
  const incluirNulo = props.incluirNulo || false;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const { ITEM_COMBO_VACIO } = UI.useUI();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const setListaDivisiones = (divisiones) => {
      if (incluirNulo) {
        setLista([{ id: null, descripcion: ITEM_COMBO_VACIO }, ...divisiones]);
      } else {
        setLista(divisiones);
      }
    };

    if (idPais) {
      fetchData(`paises/${idPais}/divisiones`, setListaDivisiones);
    } else {
      setLista(incluirNulo ? [{ id: null, descripcion: ITEM_COMBO_VACIO }] : []);
    }
  }, [fetchData, incluirNulo, idPais, ITEM_COMBO_VACIO]);

  const onItemElegido = (itemElegido) => {
    props.onDivisionElegida(itemElegido);
  };

  let valorActual = '';
  if (divisionActual) {
    if (divisionActual.descripcion) {
      valorActual = divisionActual.descripcion;
    } else if (lista.length > 0) {
      for (const element of lista) {
        if (Number(element.id) === Number(divisionActual.id)) {
          valorActual = element.descripcion;
          break;
        }
      }
    }
  }

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={valorActual}
        campoClave={TipoClave.ID}
        campoDescripcion="descripcion"
        isCargando={isCargando}
        onItemElegido={onItemElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectDivision;
